import React from "react";
import { useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function AddIncoTerms() {
  const classes = useStyles();

  const history = useHistory();
  const EmpId = localStorage.getItem("EmpId");
  // console.log(EmpId);
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          เงื่อนไขการขนส่งสินค้า
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Incoterms
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Incoterms
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{ f_t_name: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.f_t_name) {
              errors.f_t_name = " * Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                // no: values.f_t_no,
                name: values.f_t_name,
                // status: 1,
                createId: EmpId,
              };

              api
                .post("api/inco/create", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "เพิ่มข้อมูลเงื่อนไขการขนส่งสินค้าสำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/Incoterms");
                      }
                    });
                  });
                })
                .catch((err) => {
                  console.log(err);
                });

              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                เพิ่มเงื่อนไขการขนส่งสินค้า
              </h6>
              <Grid container>
                <Grid item xs={4} sm={3} md>
                  <TextField
                    name="f_t_name"
                    label="IncoTerm"
                    variant="outlined"
                    placeholder="IncoTerm"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{ width: "50%" }}
                    InputLabelProps={{ shrink: true }}
                    value={values.f_t_name}
                    classes={{ root: !values.f_t_name ? classes.customOutline : null }}
                    required
                  />
                  {/* {errors.f_t_name && touched.f_t_name && errors.f_t_name} */}
                  <br />
                  {/* <TextField
                    label="FREIGHT TERMS NO."
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter FREIGHT TERMS NO."
                    name="f_t_no"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.f_t_no}
                  />
                  {errors.f_t_no && touched.f_t_no && errors.f_t_no} */}
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                  marginTop: "15px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                  marginTop: "15px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
